// TabComponent.jsx
import React from 'react';
import PlateToolBar from '../../platewells/PlateToolBar';
import PlateWell from '../../platewells/PlateWell';
import AnalysisSetUp from '../../platewells/Analysis/AnalysisSetUp';

import QlpFileDownload from '../../platewells/fileDownloads/QlpFileDownload';

const Analysis = ({ label, content }) => {
    return (
        <>
            <div className="flex flex-grow min-h-screen border-2 border-solid">
                <div className="flex flex-col w-[100vmin] relative aspect[1]">
                    <div className="flex p-5 w-full">
                        <div className='flex-1'>
                            <PlateToolBar />
                        </div>
                        <div>
                            <QlpFileDownload />
                        </div>
                    </div>

                    <div className="flex-grow overflow-auto">
                        <PlateWell />
                    </div>
                </div>


                <div className="w-1/4">
                    <div className='plate-control-panel'>
                        <AnalysisSetUp />
                    </div>
                </div>


            </div >
            <div className="footer-area">

            </div>

        </>
    );
};

export default Analysis;
